import { apiClient } from '@/api/client'
import { API_ENDPOINTS } from '@/config/api'
import type {
  DispatchTriageRequest,
  DispatchTriageResponse,
} from '@/types/api/triage'

export const triageService = {
  async dispatchTriage(
    payload: DispatchTriageRequest
  ): Promise<DispatchTriageResponse> {
    const response = await apiClient.post<DispatchTriageResponse>(
      API_ENDPOINTS.DISPATCH_TRIAGE,
      payload,
      {
        headers: {
          'skip-auth': true,
        },
      }
    )
    return response.data
  },
}

export type TriageService = typeof triageService
